import React from 'react'
import RightArrow from 'react-icons/lib/ti/arrow-right'

export default () => (
  <div className="examples-pane">
    <div className="pane-title">See it in action</div>
    <div className="example">
      <div className="source">
        <img
          src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c0/Vice_logo.svg/1024px-Vice_logo.svg.png"
        />
      </div>
      <img
        src="https://cdn-e2.streamable.com/image/92ok4.jpg?token=1492527497_a9be287caebafd4e3c8ecd6abeb380bd420d59fb"
      />
      <div className="title">
        Why This Final Fantasy XV Player Spent 60 Hours Grinding During Chapter One
      </div>
      <a
        href="https://waypoint.vice.com/en_us/article/why-this-final-fantasy-xv-player-spent-60-hours-grinding-during-chapter-one"
      >
        View on vice.com <RightArrow />
      </a>
    </div>
    <div className="example">
      <div className="source">
        <img
          src="https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTp37-gxT-RfFwetvLBDYlZmRfdDdMzVgJAjkv9LPAktkv0HykPVZrBHr8"
        />
      </div>
      <img
        src="https://cdn-e2.streamable.com/image/clya3_1.jpg?token=1492536594_9ec86e84aca18c0fcd8b5c1d70b4491d21161efb"
      />
      <div className="title">Halo Wars 2: The Kotaku Review</div>
      <a href="https://kotaku.com/halo-wars-2-the-kotaku-review-1792373382">
        View on kotaku.com <RightArrow />
      </a>
    </div>
    <div className="example">
      <div className="source">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Huffington_Post_Logo.svg/2000px-Huffington_Post_Logo.svg.png" />
      </div>
      <img
        src="https://cdn-w2.streamable.com/image/e52e20c00f1a11e59507a5dea6851e87.jpg?token=1492536396_7cedbd05064dd8e8ac53fd7b665c27032ccb0b5f"
      />
      <div className="title">
        Watch This Diver Try And High Five The Largest Shark We’ve Ever Seen
      </div>
      <a
        href="http://www.huffingtonpost.co.uk/2015/06/11/massive-shark-meets-scuba-diver_n_7559542.html"
      >
        View on huffingtonpost.co.uk <RightArrow />
      </a>

    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/landing/Examples.js